module.exports = ".list-group-item{display:flex;justify-content:space-between}.warn{background:#b73125;color:#fff}\n"